import NestedColumnTable from "../../../Components/Table/ProductLineDrillDown";

const Salience = () => {
  return (
    <div className="grid grid-cols-1  lg:grid-cols-2 w-full gap-2">
      <NestedColumnTable
        endpoint="dealer-sales-success-centre/deal_slab_prod_line_salience"
        expansionEndpoint="dealer-sales-success-centre/deal_slab_salience"
        Heading="Deal Slab Salience"
      />

      <NestedColumnTable
        expansionEndpoint="dealer-sales-success-centre/region_salience"
        endpoint="dealer-sales-success-centre/retail_prod_line_salience"
        Heading="Region Salience"
      />
      <NestedColumnTable
        expansionEndpoint="dealer-sales-success-centre/ppl_salience"
        endpoint="dealer-sales-success-centre/retail_prod_line_salience"
        Heading="PPL Salience"
      />
      <NestedColumnTable
        expansionEndpoint="dealer-sales-success-centre/cbc_hsd_salience"
        endpoint="dealer-sales-success-centre/retail_prod_line_salience"
        Heading="CBC/HSD Salience"
      />
    </div>
  );
};

export default Salience;
